class UserPersonnelInfo {
  constructor(personnelNumber, startDate, userId, organizationRoleId) {
    this.personnelNumber = personnelNumber;
    this.startDate = startDate;
    this.userId = userId;
    this.organizationRoleId = organizationRoleId;
  }
}
import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      allUserPersonnelInfos: [],
      userPersonnelInfo: new UserPersonnelInfo('', '', null, null),
      allUserPersonnelInfosForOther: [],
    };
  },
  methods: {
    getListOfUserPersonnelInfosForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUserPersonnelInfos').then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          this.allUserPersonnelInfosForOther =
            this.$store.state.userPersonnelInfoModule.allUserPersonnelInfos;
          if (this.$route.name == 'user') {
            this.allUserUserPersonnelInfos = this.allUserPersonnelInfosForOther;
            this.readyUserUserPersonnelInfo();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfUserPersonnelInfosForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfUserPersonnelInfosForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllUserPersonnelInfos: function (userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUserPersonnelInfos', userId).then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          let temp = this.$store.state.userPersonnelInfoModule.allUserPersonnelInfos;
          this.allUserPersonnelInfos = [];
          for (let i = 0; i < temp.length; i++) {
            let startDate = '-';
            let endDate = '-';
            if (temp[i].startDate) {
              startDate = Vue.moment(temp[i].startDate).format('jYYYY/jM/jD');
            }
            if (temp[i].endDate) {
              endDate = Vue.moment(temp[i].endDate).format('jYYYY/jM/jD');
            }
            this.allUserPersonnelInfos.push({
              role: temp[i].organizationRole ? temp[i].organizationRole.title : '-',
              personnelNumber: temp[i].personnelNumber ? temp[i].personnelNumber : '-',
              startDate: startDate,
              endDate: endDate,
              counter: i + 1,
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllUserPersonnelInfos(userId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllUserPersonnelInfos(userId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addUserPersonnelInfoFunction: function () {
      if (!this.userPersonnelInfo.startDate) {
        this.snackText = 'تاریخ شروع نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.organizationRoleId) {
        this.snackText = 'سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.personnelNumber) {
        this.snackText = 'شماره پرسنلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.personnelNumber.replace(/\s/g, '').length) {
        this.snackText = 'شماره پرسنلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.userPersonnelInfo.userId = Number(this.userId);
      this.$store.dispatch('addUserPersonnelInfo', this.userPersonnelInfo).then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' اطلاعات شخصی با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.userPersonnelInfo = new UserPersonnelInfo('', '', null, null);
          this.tempUserStartDate = '';
          this.getAllUserPersonnelInfos(this.userId);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserPersonnelInfoFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUserPersonnelInfo', id).then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          let temp = this.$store.state.userPersonnelInfoModule.userPersonnelInfo;
          this.userPersonnelInfo.personnelNumber = temp.personnelNumber;
          this.userPersonnelInfo.startDate = temp.startDate;
          this.userPersonnelInfo.userId = temp.userId;
          this.userPersonnelInfo.organizationRoleId = temp.organizationRole.id;
          this.userPersonnelInfo.id = temp.id;
          this.userStartDateChange();
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserPersonnelInfoFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserPersonnelInfoFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editUserPersonnelInfoFunction: function () {
      if (!this.userPersonnelInfo.startDate) {
        this.snackText = 'تاریخ شروع نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.organizationRoleId) {
        this.snackText = 'سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.personnelNumber) {
        this.snackText = 'شماره پرسنلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userPersonnelInfo.personnelNumber.replace(/\s/g, '').length) {
        this.snackText = 'شماره پرسنلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.userPersonnelInfo.userId = Number(this.userId);
      this.$store.dispatch('editUserPersonnelInfo', this.userPersonnelInfo).then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllUserPersonnelInfos(this.userId);
          this.snackText = ' اطلاعات شخصی با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.userPersonnelInfo = new UserPersonnelInfo('', '', null, null);
          this.tempUserStartDate = '';
        } else {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteUserPersonnelInfoFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteUserPersonnelInfo', this.userPersonnelInfoId).then(() => {
        if (this.$store.state.userPersonnelInfoModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllUserPersonnelInfos(this.userId);
          this.snackText = ' اطلاعات شخصی با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userPersonnelInfoModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userPersonnelInfoModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteUserPersonnelInfoFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.userPersonnelInfoModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
